const TroubleSection = () => {
  const troubles = [
    {
      title: "入れ歯やブリッジが合ってないのでよく噛めない",
      image: "https://www.masu-dc.or.jp/lp-implant/img/pic_trouble01.jpg",
      link: "#about"
    },
    {
      title: "インプラント治療に必要なことって?",
      image: "https://www.masu-dc.or.jp/lp-implant/img/pic_trouble02.jpg",
      link: "#inspection"
    },
    {
      title: "治療を断られたことがあるのですが",
      image: "https://www.masu-dc.or.jp/lp-implant/img/pic_trouble03.jpg",
      link: "#consult"
    },
    {
      title: "インプラント治療っていくらかかるの?",
      image: "https://www.masu-dc.or.jp/lp-implant/img/pic_trouble04.jpg",
      link: "#price"
    },
    {
      title: "インプラント治療は時間がかかるって本当?",
      image: "https://www.masu-dc.or.jp/lp-implant/img/pic_trouble05.jpg",
      link: "#flow"
    },
    {
      title: "インプラント治療って痛いの?",
      image: "https://static.readdy.ai/image/4d1e24136ef2955fabe2fc9c76951eeb/7396b28465795e918a955677a1a2a1ec.jpeg",
      link: "#faq"
    }
  ];

  return (
    <section className="py-20 bg-white relative overflow-hidden">
      <div className="container mx-auto px-6 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-[#2c5f7c] mb-6">
            あなたの悩みを<br />
            聞かせてください
          </h2>
        </div>

        {/* Troubles Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {troubles.map((trouble, index) => (
            <a
              key={index}
              href={trouble.link}
              className="group bg-[#f5f1e8] rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={trouble.image}
                  alt={trouble.title}
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                />
              </div>
              
              <div className="p-6">
                <h3 className="text-lg font-bold text-[#2c5f7c] group-hover:text-[#c8a882] transition-colors duration-300 leading-relaxed">
                  {trouble.title}
                </h3>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TroubleSection;
